import { Model } from 'dva'
import { SLUModel } from './types'
import { SluModelsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const SLUModels: Model = {
  namespace: 'sluModels',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let sluModels = yield select((state: any) => state.sluModels.list)
        if (!(sluModels.length > 0 && useCache)) {
          sluModels = yield call(SluModelsService.sluModelsList, {})
          yield put({ type: 'modifyList', payload: sluModels })
        }
        onSuccess(sluModels)
      } catch (err: any) {
        FailureHandler('Error fetching SLU Models', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let sluModel = yield select((state: any) =>
          state.sluModels.list.find((sluModel: SLUModel) => sluModel.id === id)
        )
        if (!sluModel) {
          sluModel = yield call(SluModelsService.sluModelsRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: sluModel })
        onSuccess(sluModel)
      } catch (err) {
        FailureHandler('Could not find the SLU Model!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(SluModelsService.sluModelsCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a SLU Model', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(SluModelsService.sluModelsPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a SLU Model', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(SluModelsService.sluModelsDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a SLU Model', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: SLUModel) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: SLUModel) => !action.payload.map((p: SLUModel) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: SLUModel) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetSLUModels(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default SLUModels
